/**
 * startup_neon.js — Catalyst (YC Pitch Deck / Venture One-Pager)
 * ─────────────────────────────────────────────────────────────────────────────
 * Design Bible:
 *   Brand Name:   Catalyst
 *   Purpose:      VC-Backable Startup Leadership & Growth Focus
 *   Reads Like:   YC Pitch Deck / Venture One-Pager
 *   Emotion:      Bold, Growth-oriented, Modern
 *   Personality:  Bold
 *   Reading Speed: Fast, impact-oriented
 *   Scanning:     Left Slate Sidebar → Right Growth Metrics Cards
 *   Hero Moment:  Venture Growth Metrics Cards. Spanning the top of the main page,
 *                 showing funding raised, team sizes, and growth metrics (achievements).
 *   ATS Target:   Moderate ATS Compatibility
 *
 * Forbidden Elements:
 *   ✗ Serif fonts
 *   ✗ Dotted rules or centered headers
 *   ✗ Soft, faded corporate styling
 */

export const startup_neon = {
  id: 'startup-neon',
  version: 3,
  renderer: 'enterprise',
  name: 'Catalyst',
  layout: 'sidebar-left',
  theme: 'classic-navy',
  density: 'compact',
  sectionDividerStyle: 'none',
  // Narrative Shift: Achievements (growth metrics, funding, scale) leads FIRST in main column before Experience
  sectionOrder: ['personal-info', 'achievements', 'summary', 'experience', 'projects', 'education', 'skills', 'certifications'],
  components: {
    header: 'header-split',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-simple-list',
    education: 'education-sidebar',
  },
  layouts: {
    'sidebar-left': {
      component: 'sidebar-left',
      slots: {
        header: ['personal-info'],
        sidebar: ['skills', 'education', 'languages', 'certifications'],
        main: ['achievements', 'summary', 'experience', 'projects'],
      },
      overrides: {
        '--font-family-primary': '"IBM Plex Sans", "Inter", "Helvetica Neue", sans-serif',
        '--font-family-secondary': '"IBM Plex Sans", sans-serif',
        '--color-primary': '#A855F7', // Neon Violet
        '--color-secondary': '#7C3AED',
        '--color-accent': '#22C55E', // Neon Green Accent
        '--color-text-main': '#1E293B',
        '--color-text-light': '#475569',
        '--color-border': '#E2E8F0',
        '--color-bg-page': '#FFFFFF',
        '--layout-sidebar-width': '220px',
        '--layout-column-gap': '20px',
        '--layout-sidebar-bg': '#1E293B', // Dark slate background
        '--layout-sidebar-padding': '16px 12px',
        '--layout-sidebar-border': 'none',
        '--layout-sidebar-text': '#F8FAFC',
        '--spacing-margin': '20px',
        '--spacing-section-mb': '12px',
        '--spacing-item-mb': '8px',
        '--spacing-bullet-gap': '3px',
      },
    },
  },
  styleOverrides: {
    '--font-size-display': '24pt',
    '--weight-display': '800',
    '--heading-weight': '700',
    '--heading-text-transform': 'none',
    '--heading-letter-spacing': '0.01em',
    '--border-thickness-heading': '0',
    '--bullet-style': 'none',
    '--font-size-heading': '11pt',
    '--font-size-body': '9pt',
    '--font-size-bullet': '8.8pt',
    '--line-height-body': '1.45',
  },
};

export default startup_neon;
